<template>
  <div>
    <div class="comm_popup_wrap_large">
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_CATG_GRP_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <div
              class="comm_label"
            >
              {{ biddingInformationParam && biddingInformationParam[0] ? biddingInformationParam[0].bullBoardCategoryGroupName : '' }}
            </div>
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_CATG_GRP_ID')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">
              BCG_
            </div>
            <div class="comp_spacing" />
            <div class="comm_label">
              {{ categoryId }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_DESC')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-11">
            <div
              class="comm_label"
            >
              {{ biddingInformationParam && biddingInformationParam[0] ? biddingInformationParam[0].bullBoardCategoryGroupContent : '' }}
            </div>
          </div>
        </div>
      </div>
      <div class="mrB30" />

      <sui-grid
        ref="grid"
        :columns="gridColumns0"
        :dataset="'dataset0'"
        :showCountControl="false"
        :showDisplayCountControl="false"
        :rowMovable="true"
        :multiselect="false"
        :pageable="false"
      />
    </div>
    <div class="comm_btn_wrap mrB30 mrR30">
      <div class="btn_wrap">
        <sui-button
          type="button"
          class="comm_btn_border"
          @click="onCancel"
        >
          {{ $t('MSG_BTN_CLOSE') }}
        </sui-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PGE_CLB_00007_P03', // eslint-disable-line vue/name-property-casing
  props: {
    biddingInformationParam: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      COD_GNRZ_AREA: {
        label: '',
        key: '',
      },
      COD_BDD_PRGS_STT: {
        label: '',
        key: '',
      },
      categoryId: '',
    };
  },
  computed: {},
  watch: {},
  datasets: [
    {
      id: 'dataset0',
      type: 'local',
      data: 'localdata0',
      datafields: [
        {
          name: 'bullBoardCategoryItemName',
          type: 'string',
          map: 'bullBoardCategoryItemName',
        },
        {
          name: 'firstRegistrationUserId',
          type: 'string',
          map: 'firstRegistrationUserId',
        },
        {
          name: 'firstRegistrationDTM',
          type: 'string',
          map: 'firstRegistrationDTM',
        },
        {
          name: 'arraylOrder',
          type: 'string',
          map: 'arraylOrder',
        },
      ],
    },
  ],
  created() {
    this.localdata0 = [];
    this.gridColumns0 = [
      {
        text: this.$t('MSG_TXT_CATG_GRP_ITEM'),
        datafield: 'bullBoardCategoryItemName',
      },
      {
        text: this.$t('MSG_TXT_ARRAY_ORDER'),
        datafield: 'arraylOrder',
      },
      {
        text: this.$t('MSG_TXT_RGST_USR'),
        datafield: 'firstRegistrationUserId',
        createwidget: (row, column, value, htmlElement) => {
          utils
            .getGridCellFactory()
            .createCellUserName(
              row,
              column,
              value,
              htmlElement,
              {
                displayType: '1', // "1", "2" - default: "1"
                type: 'link', // 'link', 'sublink' - default: "link"
              },
              this.dataset0,
              this.$refs.grid,
            );
        },
        initwidget(row, column, value, htmlElement) {
          utils
            .getGridCellFactory()
            .refreshCell(row, column, value, htmlElement);
        },
      },
      {
        text: this.$t('MSG_TXT_RGST_DT'),
        datafield: 'firstRegistrationDTM',
        createwidget: (r, c, v, h) => utils.getGridCellFactory().createCellDateLabel(r, c, v, h, this.dataset0, this.$refs.grid),
        initwidget: (r, c, v, h) => utils.getGridCellFactory().refreshCell(r, c, v, h),          
      },
    ];
  },
  mounted() {
    this.dataset0.setRawData(this.biddingInformationParam);
    this.categoryId = this.biddingInformationParam[0].bullBoardCategoryGroupID.slice(
      4,
      this.biddingInformationParam[0].bullBoardCategoryGroupID.length,
    );
  },
  methods: {
    onCancel() {
      this.$emit('exit', true);
    },
  },
};
</script>
<style scoped>
</style>
